import {useSelector} from 'react-redux';
import {get} from 'lodash';

import {FeatureFlagKey} from '/constant/featureFlag.constants';
import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';
import {shouldReleaseFeature} from '/util/featureRelease.util';

export const useFeatureFlag = (flagKey: FeatureFlagKey): boolean => {
  const VariablesFeatureFlag = useSelector(variablesFeatureFlag);

  return shouldReleaseFeature(get(VariablesFeatureFlag, flagKey, ''));
};
